/* cross-sell-recalc.js - Глобальный скрипт для пересчета высоты cross-sell */
(function () {
  const VAR = '--croll-sell-products--height';
  const CROSS_SELL_DEBUG_ENABLED = (() => {
    if (typeof window === 'undefined') return false;
    if (typeof window.__wtCartDebug === 'boolean') return window.__wtCartDebug;
    const enabled =
      new URLSearchParams(window.location.search).get('debug') === 'true';
    window.__wtCartDebug = enabled;
    return enabled;
  })();

  const crossSellDebugLog = (...args) => {
    if (!CROSS_SELL_DEBUG_ENABLED) return;
    console.debug(...args);
  };

  const MIN_RECALC_INTERVAL = 120; // ms

  function setVar(cs, list, px) {
    const prev = parseFloat(cs.dataset.wtCrossSellHeightPx || '');
    if (!Number.isNaN(prev) && prev === px) {
      crossSellDebugLog('[CrossSellRecalc] setVar:skip-same-height', {
        px,
        crossSellClasses: cs.className,
      });
      return;
    }

    const v = `-${px}px`;
    cs.style.setProperty(VAR, v);
    list.style.setProperty(VAR, v);
    cs.dataset.wtCrossSellHeightPx = String(px);
    crossSellDebugLog('[CrossSellRecalc] setVar', {
      px,
      value: v,
      crossSellClasses: cs.className,
    });
    try {
      sessionStorage.setItem('wt-cross-sell-height', v);
    } catch (err) {
      crossSellDebugLog('[CrossSellRecalc] setVar:store-error', err);
    }
  }

  function measureWhenReady(cs) {
    const list = cs.querySelector('.wt-cart__cross-sell__products');
    if (!list) return;
    if (cs.dataset.wtCrossSellMeasuring === 'true') return;
    cs.dataset.wtCrossSellMeasuring = 'true';

    let tries = 0;
    (function tick() {
      const h = Math.ceil(list.offsetHeight);
      if (h > 0 || tries > 40) {
        crossSellDebugLog('[CrossSellRecalc] measureWhenReady:resolved', {
          tries,
          height: h,
          crossSellClasses: cs.className,
        });
        setVar(cs, list, (h + 17));
        delete cs.dataset.wtCrossSellMeasuring;
      } else {
        tries++;
        requestAnimationFrame(tick);
      }
    })();

    // Recalc when images load later
    list.querySelectorAll('img').forEach(img => {
      if (!img.complete) img.addEventListener('load', () => measureWhenReady(cs), { once: true });
    });

    // Recalc when Swiper flips into initialized state
    const swiperEl = list.closest('[data-swiper-container]');
    if (swiperEl && !swiperEl.classList.contains('swiper-initialized')) {
      crossSellDebugLog('[CrossSellRecalc] measureWhenReady:watch-swiper-init');
      watchSwiperInit(swiperEl);
    }
  }

  function watchSwiperInit(swiperEl) {
    if (!swiperEl) return;
    const obs = new MutationObserver(muts => {
      if (swiperEl.classList.contains('swiper-initialized')) {
        obs.disconnect();
        const cs = swiperEl.closest('.wt-cart__cross-sell');
        if (cs) measureWhenReady(cs);
        crossSellDebugLog('[CrossSellRecalc] swiper initialized, recalculating');
      }
    });
    obs.observe(swiperEl, { attributes: true, attributeFilter: ['class'] });
  }

  function recalc(root = document) {
    let targets = [];
    if (root === document) {
      targets = Array.from(document.querySelectorAll('.wt-cart__cross-sell'));
    } else if (root.matches?.('.wt-cart__cross-sell')) {
      targets = [root, ...root.querySelectorAll('.wt-cart__cross-sell')];
    } else if (root.querySelectorAll) {
      targets = Array.from(root.querySelectorAll('.wt-cart__cross-sell'));
    }

    crossSellDebugLog('[CrossSellRecalc] recalc', {
      rootTag: root === document ? 'document' : root.tagName,
      crossSells: targets.length,
    });

    if (!targets.length && root !== document) {
      crossSellDebugLog('[CrossSellRecalc] recalc: no cross-sell elements found for root');
    }

    const now = performance?.now?.() ?? Date.now();
    targets.forEach((cs) => {
      const last = parseFloat(cs.dataset.wtCrossSellLastRecalc || '');
      if (!Number.isNaN(last) && now - last < MIN_RECALC_INTERVAL) {
        crossSellDebugLog('[CrossSellRecalc] recalc:skip-too-soon', {
          elapsed: now - last,
          min: MIN_RECALC_INTERVAL,
        });
        return;
      }
      cs.dataset.wtCrossSellLastRecalc = String(now);
      measureWhenReady(cs);
    });
  }

  // Экспортируем recalc для использования из других скриптов
  window.__crossSellRecalc = recalc;

  // Initial
  document.addEventListener('DOMContentLoaded', () => recalc());
  document.addEventListener('DOMContentLoaded', () => crossSellDebugLog('[CrossSellRecalc] DOMContentLoaded'));

  // Theme editor section reloads
  document.addEventListener('shopify:section:load', e => recalc(e.target));

  // Your add-to-cart event - множественные пересчеты для надежности
  document.addEventListener('cart-drawer:refresh', () => {
    crossSellDebugLog('[CrossSellRecalc] cart-drawer:refresh event');
    setTimeout(() => {
      recalc();
      setTimeout(() => recalc(), 200);
      setTimeout(() => recalc(), 400);
    }, 50);
  });

  // Window resize
  function debounce(fn, ms) { 
    let t; 
    return (...a) => { 
      clearTimeout(t); 
      t = setTimeout(() => fn(...a), ms); 
    }; 
  }
  window.addEventListener('resize', debounce(() => recalc(), 150));

  // Делегирование событий для toggle cross-sell
  if (!document.__crossSellToggleHandler) {
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-cross-sell-toggle]');
      if (toggle) {
        crossSellDebugLog('[CrossSellRecalc] cross-sell toggle click');
        e.preventDefault();
        e.stopPropagation();
        const crossSell = toggle.closest('.wt-cart__cross-sell');
        if (crossSell) {
          const isCollapsed = crossSell.classList.toggle('wt-cart__cross-sell--collapsed');
          if (isCollapsed) {
            sessionStorage.setItem('wt-cross-sell-collapsed', 'true');
            try {
              const currentHeight = getComputedStyle(crossSell).getPropertyValue(VAR)?.trim();
              if (currentHeight) {
                sessionStorage.setItem('wt-cross-sell-height', currentHeight);
                crossSellDebugLog('[CrossSellRecalc] toggle:stored-height', currentHeight);
              }
            } catch (err) {
              crossSellDebugLog('[CrossSellRecalc] toggle:store-height-error', err);
            }
          } else {
            sessionStorage.removeItem('wt-cross-sell-collapsed');
            sessionStorage.removeItem('wt-cross-sell-height');
            delete crossSell.dataset.wtCrossSellHeightPx;
          }
          recalc(crossSell);
        }
      }
    });
    document.__crossSellToggleHandler = true;
  }

  // Восстанавливаем состояние collapsed при загрузке cross-sell
  function restoreCrossSellOnLoad(root = document) {
      const crossSell = root.querySelector('.wt-cart__cross-sell');
      if (crossSell) {
        const shouldBeCollapsed = sessionStorage.getItem('wt-cross-sell-collapsed') === 'true';
        crossSellDebugLog('[CrossSellRecalc] restoreCrossSellOnLoad', {
          shouldBeCollapsed,
          classes: crossSell.className,
        });
        if (shouldBeCollapsed) {
          crossSell.classList.add('wt-cart__cross-sell--collapsed');
          try {
            const storedHeight = sessionStorage.getItem('wt-cross-sell-height');
            if (storedHeight) {
              crossSell.style.setProperty(VAR, storedHeight);
              const list = crossSell.querySelector('.wt-cart__cross-sell__products');
              list?.style.setProperty(VAR, storedHeight);
              const numeric = parseFloat(storedHeight.replace(/[^\d.]/g, ''));
              if (!Number.isNaN(numeric)) {
                crossSell.dataset.wtCrossSellHeightPx = String(numeric);
              }
              crossSellDebugLog('[CrossSellRecalc] restore:applied-stored-height', storedHeight);
            }
          } catch (err) {
            crossSellDebugLog('[CrossSellRecalc] restore:apply-height-error', err);
          }
          requestAnimationFrame(() => {
            recalc(crossSell);
          });
        } else {
          // crossSell.classList.remove('wt-cart__cross-sell--collapsed');
          delete crossSell.dataset.wtCrossSellHeightPx;
          requestAnimationFrame(() => {
            recalc(crossSell);
          });
        }
    }
  }

  document.addEventListener('DOMContentLoaded', () => restoreCrossSellOnLoad());
  
  document.addEventListener('cart-drawer:refresh', () => {
    crossSellDebugLog('[CrossSellRecalc] cart-drawer:refresh -> restoreCrossSellOnLoad');
    restoreCrossSellOnLoad();
    setTimeout(() => {
      recalc();
      setTimeout(() => recalc(), 200);
      setTimeout(() => recalc(), 400);
    }, 100);
  });

  // MutationObserver для отслеживания добавления cross-sell
  const mo = new MutationObserver(muts => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.matches?.('.wt-cart__cross-sell') || n.querySelector?.('.wt-cart__cross-sell')) {
          crossSellDebugLog('[CrossSellRecalc] MutationObserver: new cross-sell detected');
          restoreCrossSellOnLoad(n);
          setTimeout(() => {
            recalc(n);
            setTimeout(() => recalc(n), 200);
          }, 50);
          return;
        }
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });

  // Optional: ensure we recalc right after your add() completes
  const _origAdd = window.WT_addShoppableToCart;
  if (typeof _origAdd === 'function') {
    window.WT_addShoppableToCart = async function(e){
      crossSellDebugLog('[CrossSellRecalc] WT_addShoppableToCart override invoked');
      const res = await _origAdd.call(this, e);
      recalc();
      return res;
    };
  }
})();
